export const i18nScope = 'fa.audi.partner-business-card';
